/** Viewport at or below this width uses overlay sidebar + auto-collapsed nav. */
export const TABLET_MAX_WIDTH = 1200;

/** Phone-sized layouts (stacked rows, compact table cells, etc.). */
export const MOBILE_MAX_WIDTH = 768;

export function isTabletOrBelow() {
  return typeof window !== "undefined" && window.innerWidth <= TABLET_MAX_WIDTH;
}

export function isMobileViewport() {
  return typeof window !== "undefined" && window.innerWidth <= MOBILE_MAX_WIDTH;
}
